import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "col-sm-12 col-md-12"
}
const _hoisted_2 = { class: "card border h-100" }
const _hoisted_3 = { class: "card-body d-flex flex-center flex-column p-9" }
const _hoisted_4 = {
  key: 0,
  id: "userPiechart",
  class: "w-100"
}
const _hoisted_5 = {
  key: 1,
  class: "col-sm-12 col-md-6"
}
const _hoisted_6 = { class: "card border h-100" }
const _hoisted_7 = { class: "card-body d-flex flex-center flex-column p-9" }
const _hoisted_8 = {
  key: 0,
  id: "userPiechart",
  class: "w-100"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_apexchart = _resolveComponent("apexchart")!

  return (_ctx.column)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            (!_ctx.lineChartLoading)
              ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                  _createVNode(_component_apexchart, {
                    ref: "chart",
                    class: "mixed-widget-5-chart card-rounded-top",
                    options: _ctx.lineChartOptions,
                    series: _ctx.lineSeries,
                    type: "area",
                    height: _ctx.height
                  }, null, 8, ["options", "series", "height"])
                ]))
              : _createCommentVNode("", true)
          ])
        ])
      ]))
    : (_openBlock(), _createElementBlock("div", _hoisted_5, [
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("div", _hoisted_7, [
            (!_ctx.lineChartLoading)
              ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                  _createVNode(_component_apexchart, {
                    ref: "chart",
                    class: "mixed-widget-5-chart card-rounded-top",
                    options: _ctx.lineChartOptions,
                    series: _ctx.lineSeries,
                    type: "area"
                  }, null, 8, ["options", "series"])
                ]))
              : _createCommentVNode("", true)
          ])
        ])
      ]))
}